import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";

import { ReactComponent as UnpublishSvg } from '../assets/unpublish.svg';

export default function PublishButton ({project_status, save}) {
     
    const [status, setStatus] = useState(project_status);
    
    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [publishMessage, changePublishMessage] = useState('');
    const setPublishMessage = (text) => {
        changePublishMessage(text)
        setTimeout(() => {
            changePublishMessage();
        }, 5000);
    };
    const publishButton = async () => {
        setStatus('publish');
        save({status: 'publish'});
        setPublishMessage ('Successfully publish');
    }
    const unpublishButton = async () => {
        setStatus('draft');
        save({status: 'draft'});
        setPublishMessage ('Successfully unpublish');
    }
    
    return (    
        
        <div className="buttons_publish_unpublish">
        
            {status == 'publish' ? 
                                    
                    <div className="button_unpublish button_noborder"
                        onClick={handleSubmit(unpublishButton)}
                    >
                        <UnpublishSvg />
                        Unpublish
                    </div>
                    
            :                                     
                
                    <button className="button_publish button check"
                        onClick={handleSubmit(publishButton)}
                    >Publish</button>
                    
            }                                
            <div className="error">{ publishMessage }</div>
            
        </div>
        
    )

}
        
